import { grey } from '@material-ui/core/colors';

export default (theme) => ({
  container: { marginBottom: theme.spacing(3) },
  eventListItem: {
    marginBottom: '2rem',
    backgroundColor: grey[200],
  },
  actions: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  divider: { margin: '.5em 0' },
  updateButtonContainer: { position: 'relative' },
  updateProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  commentFormContainer: { marginTop: 16 },
  input: { '&:focus': { background: 'unset' } },
});
